var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.05721 18.9605H14.4595C16.3043 18.9605 17.8058 17.5887 17.8058 15.9031V11.6319C17.8058 11.38 17.5802 11.1739 17.3045 11.1739C17.0287 11.1739 16.8031 11.38 16.8031 11.6319V15.9031C16.8031 17.0825 15.7529 18.0444 14.4595 18.0444H4.05721C2.76382 18.0444 1.71357 17.0848 1.71357 15.9031V6.40114C1.71357 5.2217 2.76382 4.25982 4.05721 4.25982H8.33092C8.60664 4.25982 8.83224 4.05371 8.83224 3.80179C8.83224 3.54987 8.60664 3.34375 8.33092 3.34375H4.05721C2.21238 3.34375 0.710938 4.71557 0.710938 6.40114V15.9031C0.710938 17.591 2.21238 18.9605 4.05721 18.9605Z",
    fill: "#77B9A0",
    stroke: "#FEB646",
    strokeWidth: 1.42738
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 2.71094L17.768 5.34418L11.2709 11.6343L8.44881 11.463L8.62786 9.00109L15.125 2.71094Z",
    fill: "#FEB646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6482 1.22831C17.028 0.860592 17.636 0.861415 18.006 1.23015L19.3088 2.52815C19.6789 2.89688 19.671 3.49389 19.2912 3.8616L18.3546 4.7683L15.7116 2.13501L16.6482 1.22831Z",
    fill: "#FEB646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit1);
export default __webpack_public_path__ + "static/media/Edit (1).7b98a422e8fe001de574daf8286802d4.svg";
export { ForwardRef as ReactComponent };